import type { ToolDefinition } from './types';
import { resolveObject } from '../agent-helpers';
import { inspectorData } from '../recipes/native-inspector';
import { getUndoManager, AddBehaviorCommand, BehaviorCommitCommand } from 'trace-viewer/editor';
import { dispatchBehaviorChanged } from '../../editor-events';

export const configureInspectorTool: ToolDefinition = {
    tool: {
        name: 'configure_inspector',
        input_schema: {
            type: 'object', properties: {
                object: { type: 'string' },
                focus: { type: 'string' },
                title: { type: 'string' }, readout: { type: 'string' },
                width: { type: 'number', minimum: 240, maximum: 480 },
                views: { type: 'array', minItems: 1, maxItems: 4, items: {
                    type: 'object', properties: { label: { type: 'string', maxLength: 24 }, yaw: { type: 'number' }, pitch: { type: 'number', minimum: 0, maximum: 180 }, radiusScale: { type: 'number', minimum: 1, maximum: 3 } }, required: ['label', 'yaw', 'pitch'],
                } },
            }, required: ['object', 'focus'],
        },
    },
    execute: async (input, ctx) => {
        try {
            if (typeof input.object !== 'string' || typeof input.focus !== 'string') throw new Error('object and focus are required');
            const owner = resolveObject(input.object, ctx), focus = resolveObject(input.focus, ctx);
            if (!owner || !focus) throw new Error('Inspector owner or focus object was not found');
            const data = inspectorData(owner, focus, input);
            const existing = owner.getBehavior('AutoUI'), before = existing?.getData();
            if (existing) {
                const errors = await existing.commit(data);
                if (errors.length) throw new Error(JSON.stringify(errors));
            } else await owner.setBehavior('AutoUI', { ...data });
            const after = owner.getBehavior('AutoUI')!.getData();
            getUndoManager().push(before ? new BehaviorCommitCommand(owner, 'AutoUI', before, after) : new AddBehaviorCommand(owner, 'AutoUI', after));
            dispatchBehaviorChanged({ objectPath: owner.getPath(), behaviorType: 'AutoUI', action: before ? 'updated' : 'added' });
            return `Configured native inspector on "${owner.name}"; ${data.cameraViews!.length} views focus "${focus.name}". Mobile starts collapsed. Frame the initial presentation with focus_camera on "${focus.name}" and save_scene to persist.`;
        } catch (error) { return `Error configuring inspector: ${error instanceof Error ? error.message : String(error)}`; }
    },
};
